<child-header title="Confirm Azure Reserved Instance Purchase" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <p>
      Order total is &nbsp;<span class="color-red bold">{{data.totalAzureRiPendingPrice |
      currency:'AUD':'symbol-narrow':'.2-2'}}</span>&nbsp;&nbsp;
    </p>
    <mat-form-field>
      <input matInput numberLettersOnly type="text" (input)="commonService.subscription_customer_ref_validation($event)" maxlength="30" class="poReference" [(ngModel)]="azureRiPoReference" placeholder="PO REFERENCE" />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large continue" (click)="continueSaveAzureRi()">Continue</button>
  </div>
</div>